export default __webpack_public_path__ + "static/imageFourthSection-b35af3d6af7f740eb46973bf4e2e46cc.svg";